(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const run = () => {
      const roots = document.querySelectorAll('[data-lux-look]');
      if (!roots.length) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const targets = [];
      roots.forEach((r) => r.querySelectorAll('.lux-look__frame, .lux-look__over, .lux-look__copy, .lux-look__head, .lux-look__caption, .lux-look__cta').forEach((el) => targets.push(el)));
      const seen = (el) => el.classList.add('is-seen');
      if (!('IntersectionObserver' in window) || reduced) { targets.forEach(seen); return; }
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { seen(e.target); io.unobserve(e.target); } }), { threshold: 0.18 });
      targets.forEach((t) => io.observe(t));
      setTimeout(() => targets.forEach(seen), 6000);
      const pars = [...document.querySelectorAll('[data-lux-par]')];
      let tick = false;
      const upd = () => {
        tick = false;
        const vh = innerHeight;
        pars.forEach((f) => {
          const r = f.getBoundingClientRect();
          if (r.bottom < -100 || r.top > vh + 100) return;
          const k = parseFloat(f.dataset.luxPar) || 0.1;
          const c = (r.top + r.height / 2 - vh / 2);
          const img = f.querySelector('.lux-look__img');
          if (img) img.style.setProperty('--lp', (-c * k).toFixed(1));
        });
      };
      addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
      upd();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  } catch(e) { console.error(e); }
})();
})();
